import styled from 'styled-components';

export const Wrapper = styled.div<{ isSelected: boolean }>`
  margin: 5px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 80px;
  padding: 10px;
  cursor: pointer;
  background: ${({ isSelected }) => (isSelected ? '#e9f3fd' : 'none')};
  transition: background 0.3s ease-out;

  &:hover {
    background: #e9f3fd;
  }
`;

export const TagName = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
  color: #4a4a4a;
`;

export const TagValue = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 33px;
  text-align: left;
`;

export const MetricTagName = styled(TagName)`
  color: #1556ff;
`;

export const MetricTagValue = styled(TagValue)`
  color: #1f1f1f;
`;
